import { useParams, useRouter } from "@tanstack/react-router";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { Button } from "../base/buttons/button";

// React (JSX) version
export function NotFound() {
	const router = useRouter();
	const { t } = useAppTranslation();
	const params = useParams({ strict: false });
	const currentOrgId = (params as { orgId?: string }).orgId ?? "unknown";

	const canGoBack = () => {
		// Get the current history state
		const history = router.history;
		const state = router.state;

		// Routes to exclude from going back to
		const excludedRoutes = ["/login", "/unauthorized", "/signed-out"];

		// Check if we have a previous location and it's not an excluded route
		const canGoBackValue =
			history.location.state?.key &&
			!excludedRoutes.some(
				(route) =>
					state.location.pathname.includes(route) ||
					history.location.pathname.includes(route),
			);

		return canGoBackValue;
	};

	const handleGoBack = () =>
		canGoBack()
			? router.history.back()
			: router.navigate({
					to: `/web/${currentOrgId}/home`,
					viewTransition: {
						types: ["not-found-home", "slide-down"],
					},
				});

	return (
		<div className="flex items-center justify-center h-[90vh]">
			<div className="text-center">
				<h1 className="text-6xl font-extrabold ">404</h1>
				<p className="text-2xl mt-4 ">{t("notFound.pageNotFound")}</p>
				<p className="mt-2 ">{t("notFound.pageNotFoundDescription")}</p>
				<Button onClick={handleGoBack} className="mt-6">
					{canGoBack() ? t("notFound.goBack") : t("notFound.goBackHome")}
				</Button>
			</div>
		</div>
	);
}
